<template>
  <div class="mod-production-demand">
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="物料编码"><el-input v-model="q.materialCode" size="small" clearable /></el-form-item>
      <el-form-item label="建议方式">
        <el-select v-model="q.suggestType" size="small" clearable style="width:120px">
          <el-option label="自制" value="make" />
          <el-option label="外购" value="buy" />
          <el-option label="委外" value="subcontract" />
        </el-select>
      </el-form-item>
      <el-form-item><el-button v-if="isAuth('production:productionDemand:list')" type="primary" size="small" @click="search">查询</el-button></el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" width="50" />
      <el-table-column prop="salesOrderCode" label="销售订单" min-width="130" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" />
      <el-table-column prop="materialName" label="物料名称" min-width="150" />
      <el-table-column label="建议方式" width="100"><template slot-scope="scope">{{ suggestTypeLabel(scope.row.suggestType) }}</template></el-table-column>
      <el-table-column prop="orderQty" label="销售需求" width="100" align="right" />
      <el-table-column prop="safetyDemandQty" label="安全库存需求" width="120" align="right" />
      <el-table-column prop="mpsDemandQty" label="MPS需求" width="100" align="right" />
      <el-table-column prop="allocatedQty" label="已分配" width="100" align="right" />
      <el-table-column prop="remainQty" label="总需求" width="100" align="right" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-size="20" layout="total, prev, pager, next" :total="total"
      @current-change="p => { pageIndex = p }" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'ProductionDemand',
  data() {
    return {
      q: { materialCode: '', suggestType: '' }, list: [], loading: false, pageIndex: 1, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  computed: {
    filtered() {
      return this.list.filter(row => {
        if (this.q.suggestType && String(row.suggestType || '') !== this.q.suggestType) return false
        return true
      })
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * 20, this.pageIndex * 20) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    suggestTypeLabel(value) {
      return { make: '自制', buy: '外购', subcontract: '委外' }[String(value || '')] || value || '—'
    },
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plan/demand/list', { params: { keyword: this.q.materialCode } }).then(res => {
        this.list = res.data || []
      }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
</style>
